<template>
  <div class="page-container">
    <main class="main-content">
      <div class="page-inner-box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
          <el-breadcrumb-item to="/exam">考试</el-breadcrumb-item>
          <el-breadcrumb-item>考试列表</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="exam-list-section">
          <div class="section-header">
            <div class="section-title">考试列表</div>
          </div>

          <div class="hall-tabs-centered">
            <div class="ht-item" :class="{active: hallStatusTab==='进行中'}" @click="hallStatusTab='进行中'">进行中</div>
            <div class="ht-item" :class="{active: hallStatusTab==='未开始'}" @click="hallStatusTab='未开始'">未开始</div>
            <div class="ht-item" :class="{active: hallStatusTab==='历史考试'}" @click="hallStatusTab='历史考试'">历史考试</div>
          </div>

          <div v-loading="hallLoading" class="hlist" :class="halls.length === 1 ? 'grid-mode-single' : 'grid-mode-multi'">
            <div class="exam-card" v-for="h in halls" :key="h.id">
              <div class="ec-head">
                <span class="ec-tag">{{ h.category }}</span>
                <span class="ec-title">{{ h.title }}</span>
              </div>
              <div class="ec-body">
                <div class="ec-row">考试时间：{{ h.start }} - {{ h.end }}</div>
                <div class="ec-row">考试时长：{{ h.duration }}分钟 <span class="sep"></span> 总分：{{ h.total }}分 <span class="sep"></span> 及格分数：{{ h.pass }}分</div>
              </div>
              <div class="ec-foot">
                <el-button v-if="h.status==='ongoing'" class="enter-btn" round size="small" @click="doExam(h)">进入考试 ></el-button>
                <el-button v-else-if="h.status==='upcoming'" type="info" plain round size="small" disabled>未开始</el-button>
                <el-button v-else type="info" plain round size="small" disabled>已结束</el-button>
              </div>
            </div>
            <el-empty v-if="halls.length === 0 && !hallLoading" description="暂无考试" style="grid-column: span 2;" />
          </div>

          <div v-if="hallTotal > hallPageSize" class="pagination">
            <el-pagination
              layout="prev, pager, next"
              :total="hallTotal"
              :page-size="hallPageSize"
              :current-page="hallPageNum"
              prev-text="<"
              next-text=">"
              @current-change="handlePageChange"
            />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { getFrontendExamList } from '@/api/examApi'

export default {
  name: 'ExamList',
  data() {
    return {
      hallStatusTab: '进行中',
      hallPageNum: 1,
      hallPageSize: 10,
      hallTotal: 0,
      hallLoading: false,
      halls: []
    }
  },
  watch: {
    hallStatusTab() {
      this.hallPageNum = 1
      this.fetchExamList()
    }
  },
  mounted() {
    this.fetchExamList()
  },
  methods: {
    async fetchExamList() {
      this.hallLoading = true
      try {
        let status = 1
        if (this.hallStatusTab === '未开始') status = 0
        else if (this.hallStatusTab === '历史考试') status = 2

        const res = await getFrontendExamList({
          pageNum: this.hallPageNum,
          pageSize: this.hallPageSize,
          status
        })
        const list = (res && res.data && res.data.list) || []
        this.hallTotal = (res && res.data && res.data.total) || 0

        this.halls = list.map(item => {
          let st = 'ongoing'
          if (item.status === 0) st = 'upcoming'
          else if (item.status === 2) st = 'ended'
          
          return {
            id: item.id,
            category: item.courseName || '财税金融',
            title: item.examName,
            start: item.examStartTime,
            end: item.examEndTime,
            duration: item.answerDuration,
            total: item.totalScore,
            pass: item.passScore,
            status: st
          }
        })
      } catch (err) {
        this.halls = []
        this.hallTotal = 0
      } finally {
        this.hallLoading = false
      }
    },
    handlePageChange(page) {
      this.hallPageNum = page
      this.fetchExamList()
    },
    doExam(h) {
      const isLoggedIn = this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.isLoggedIn
      if (!isLoggedIn) {
        window.dispatchEvent(new Event('auth:login-required'))
        return
      }
      this.$router.push({
        name: 'examIntro',
        params: { id: h.id },
        query: {
          title: h.title,
          start: h.start,
          end: h.end,
          duration: h.duration,
          total: h.total,
          pass: h.pass
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  min-height: 100vh;
  background: #f4f6f8;
}

.main-content {
  flex: 1;
  padding: 20px 0 40px;
}

.exam-list-section {
  margin-top: 20px;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
}

.section-header {
  margin-bottom: 16px;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.hall-tabs-centered {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 24px;
}

.ht-item {
  padding: 8px 24px;
  border-radius: 20px;
  background: #f5f7fa;
  color: #606266;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.ht-item:hover {
  background: #eef2ff;
  color: #3E2CCD;
}

.ht-item.active {
  background: #3E2CCD;
  color: #fff;
  font-weight: 500;
}

.hlist.grid-mode-multi {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.hlist.grid-mode-single {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.exam-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e4e7ed;
  transition: all 0.3s;
}

.exam-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-color: #3E2CCD;
}

.ec-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.ec-tag {
  background: #eef2ff;
  color: #3E2CCD;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}

.ec-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.ec-body {
  margin-bottom: 16px;
}

.ec-row {
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
}

.sep {
  margin: 0 12px;
  color: #dcdfe6;
}

.ec-foot {
  display: flex;
  justify-content: flex-end;
}

.enter-btn {
  border-color: #3E2CCD;
  color: #3E2CCD;
  padding: 8px 24px;
}

.enter-btn:hover, .enter-btn:focus {
  background: #3E2CCD;
  color: #fff;
  border-color: #3E2CCD;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

@media (max-width: 768px) {
  .hlist.grid-mode-multi, .hlist.grid-mode-single {
    grid-template-columns: 1fr;
  }
}
</style>